import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';
import isEmail from 'validator/lib/isEmail';

import { MODULE_MESSAGE } from '../../../../../../../data/config/urls';

import SelectItem from '../../../../../../../components/form/selectitem';
import ModalFooter from '../../../../../../../components/modalfooter';

const { RangePicker } = DatePicker;
const work_sheet_options = ["Chat Report Raw Dump", "Chat Message Report Summary", "Total Chats Report"];

class ShareReport extends React.PureComponent {
  state = {
    emailIds: [],
    startDate: moment(new Date(), "DD-MM-YYYY").subtract(1.75, 'hours'),
    endDate: moment(new Date(), "DD-MM-YYYY"),
    worksheetName: [],
    email_error: '',
    work_sheet_error: '',
  }

  onChangeDateRange = date_range => {
    this.setState({
      startDate: date_range[0],
      endDate: date_range[1]
    });
  }

  onChangeWorkSheetName = worksheetName => {
    const { work_sheet_error } = this.state;
    if (work_sheet_error.length > 0)
      this.setState({ work_sheet_error: '' });
    this.setState({ worksheetName });
  }

  onChangeEmailIds = emailIds => {
    const { email_error } = this.state;
    if (email_error.length > 0)
      this.setState({ email_error: '' })
    this.setState({ emailIds });
  }

  handleOkClick = () => { 
    const { handleSendClick } = this.props;
    const { emailIds, startDate, endDate, worksheetName } = this.state;
    if (emailIds.length > 0 && worksheetName.length > 0) {
      const index = emailIds.findIndex(email => !isEmail(email));
      if (index === -1) {
        const payload = {
          worksheetName,
          startDate,
          endDate,
          emailId: emailIds,
        };
        handleSendClick(payload);
      } else {
        this.setState({ email_error: 'email ids are not valid.' });
      }
    } else {
      this.setState({
        email_error: emailIds.length > 0 ? '' : 'email ids are required.',
        work_sheet_error: worksheetName.length > 0 ? '' : 'work sheet name is required.',
      })
    }
  }

  render() {
    const { emailIds, startDate, endDate, worksheetName, work_sheet_error, email_error } = this.state;
    const { loading, handleCancelClick } = this.props;
    const modal_footer_props = {
      button_ok_text: "Send",
      loading,
      handleOkClick: this.handleOkClick,
      handleCancelClick,
    };

    return (
      <div className="ori-pad-15">
        <p className="ori-font-light ori-font-13">{MODULE_MESSAGE.ANALYTICS.USAGES.share_report}</p>
        <div className="ori-lr-pad-10 ori-tb-pad-10">
          <div className="ori-tb-mrgn-10 ori-flex-row ori-flex-jc">
            <RangePicker size="small" className="ori-range-picker-default" showTime={{ format: 'HH:mm A' }} placeholder={['Start Time', 'End Time']} format="hh:mm A, DD MMM YYYY" value={[startDate, endDate]} onChange={this.onChangeDateRange} />
          </div>
          <SelectItem mode='multiple' title="Work Sheet Name" placeholder="Enter Work Sheet Name" value={worksheetName} options={work_sheet_options} message={work_sheet_error} onChange={this.onChangeWorkSheetName} show_search allow_clear />
          <SelectItem mode='tags' title="Email Ids" placeholder="Enter Email id" value={emailIds} options={null} message={email_error} onChange={this.onChangeEmailIds} allow_clear />
        </div>
        <ModalFooter {...modal_footer_props} />
      </div>
    );
  }
}

ShareReport.propTypes = {
  handleCancelClick: PropTypes.func,
  handleSendClick: PropTypes.func,
  loading: PropTypes.bool,
};

ShareReport.defaultProps = {
  loading: false,
};

export default ShareReport;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/agentmonitoring/components/sharereport/index.js